import { render, staticRenderFns } from "./NewCourse.vue?vue&type=template&id=263e2f66&scoped=true"
import script from "./NewCourse.vue?vue&type=script&lang=js"
export * from "./NewCourse.vue?vue&type=script&lang=js"
import style0 from "./NewCourse.vue?vue&type=style&index=0&id=263e2f66&prod&lang=scss"
import style1 from "./NewCourse.vue?vue&type=style&index=1&id=263e2f66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e2f66",
  null
  
)

export default component.exports